import user from './user';

export default {
	userPage: user
}
